import gql from 'graphql-tag';

export const RETRY_PFA_BOOST_REWARD_MUTATION = gql`
mutation RetryPFABoostReward($boostRewardIds: [Int!]!) {
    retryPFABoostReward(boostRewardIds: $boostRewardIds)
}
`;
